import React from 'react';
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from 'react-router';

import { Button } from '@/components/ui/button';
import { cn } from '@/utils/classname';

interface LinkProps extends ReactRouterLinkProps {
  styleType?:
    | 'textPrimary'
    | 'primary'
    | 'secondary'
    | 'text'
    | 'header'
    | 'primaryLight'
    | 'rounded'
    | 'error'
    | 'icon'
    | 'none';
  newTab?: boolean;
  buttonClass?: string;
  disabled?: boolean;
}

const styleTypeToVariant: Record<
  string,
  React.ComponentProps<typeof Button>['variant']
> = {
  primary: 'default',
  secondary: 'secondary',
  text: 'ghost',
  textPrimary: 'link',
  header: 'secondary',
  primaryLight: 'ghost',
  rounded: 'outline',
  error: 'destructive',
  icon: 'ghost',
  none: 'ghost',
};

export function Link(props: LinkProps) {
  const {
    styleType = 'textPrimary',
    newTab,
    buttonClass,
    disabled,
    ...linkProps
  } = props;

  const isNewTab =
    newTab ||
    (typeof linkProps.to === 'string' && linkProps.to.startsWith('http'));

  const variant = styleTypeToVariant[styleType] ?? 'link';

  return (
    <Button
      asChild
      variant={variant}
      className={cn(buttonClass, disabled && 'pointer-events-none opacity-50')}
    >
      <ReactRouterLink
        {...linkProps}
        {...(isNewTab ? { target: '_blank', rel: 'noreferrer' } : {})}
        onClick={
          disabled
            ? (e: React.MouseEvent) => e.preventDefault()
            : linkProps.onClick
        }
        aria-disabled={disabled || undefined}
      >
        {props.children}
      </ReactRouterLink>
    </Button>
  );
}
